import React, { useEffect, useState } from "react";
import sort from "../../../assets/sort.png";
import frontIcon from "../../../assets/front.png";
import backIcon from "../../../assets/back.png";
import forwardIcon from "../../../assets/forward.png";
import backwardIcon from "../../../assets/backward.png";
import deleteIcon from "../../../assets/delete.png";
import { Form } from "react-bootstrap";
import "./service.scss";
import { useSessionListQuery } from "../../../../services/listener"; // Adjust the import path as necessary
import moment from "moment";
import { useNavigate } from "react-router-dom";

function Services({ searchTerm, dateRange, setExcelSessionData }) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const handleView = (id) => {
    navigate(`/dashboard/user-management/profile-view?id=${id}`);
  };
  const handleView2 = (id) => {
    navigate(`/dashboard/listener-management/profile-view?id=${id}`);
  };
  // Fetch session data using the query
  const { data, error, isLoading } = useSessionListQuery({
    page,
    limit: pageSize,
    search: searchTerm,
    fromDate: dateRange[0]?.toISOString(),
    toDate: dateRange[1]?.toISOString(),
  });
  useEffect(() => {
    if (data?.data) {
      setExcelSessionData(data.data);
    }
  }, [data]);
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error fetching session data: {error.message}</div>;

  const total = data.total || 0;

  return (
    <div className="services-main">
      <div className="table-headings">
        <div>
          <p className="heading-text">Sr. No</p>
        </div>
        <div>
          <p className="heading-text">
            Service Type
            <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            user <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            listener <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            Minute <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            Total Amount <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            Net Amount <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            Admin Commission <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text">
            Transaction Status <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text ">
            Transaction Date
            <img className="sort" src={sort} alt={sort} />
          </p>
        </div>
        <div>
          <p className="heading-text ">Action</p>
        </div>
      </div>

      {data.data.map((session, index) => (
        <div key={session.id} className="table-body">
          <div>
            <p className="heading-text">
              {page && pageSize !== "all"
                ? (page - 1) * pageSize + index + 1
                : index + 1}
            </p>
          </div>
          <div>
            <p className="heading-text">{session?.service_type}</p>
          </div>
          <div>
            <p
              onClick={() => handleView(session?.userId)}
              className="heading-text name"
            >
              {session.username}
            </p>
          </div>
          <div>
            <p
              onClick={() => handleView2(session?.listenerId)}
              className="heading-text name"
            >
              {session.listenerName}
            </p>
          </div>
          <div>
            <p className="heading-text">{session.totalDuration}</p>
          </div>
          <div>
            <p className="heading-text">{session.total_amount}</p>
          </div>
          <div>
            <p className="heading-text">{session.listener_credit}</p>
          </div>
          <div>
            <p className="heading-text">{session.admin_credit}</p>
          </div>
          <div>
            <p className="heading-text green-text">
              {session.transaction_status}
            </p>
          </div>
          <div>
            <p className="heading-text extra-space">
              {moment(session.createdAt).format("DD/MM/YYYY, hh:mm A")}
            </p>
          </div>
          <div>
            <img src={deleteIcon} alt={deleteIcon} />
          </div>
        </div>
      ))}

      <div className="pagination">
        <div className="pagination-dropdown">
          <p>Items Per Pages:</p>
          <Form.Select
            aria-label="Default select example"
            onChange={(e) => {
              setPageSize(e.target.value);
              setPage(1); // Reset to first page when page size changes
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="all">All</option>
          </Form.Select>
        </div>
        <div className="pagination-details">
          <div className="pagination-numbers">
             <p>{(page - 1) * pageSize + 1}</p>-
            <p>{Math.min(page * pageSize, total)}</p>
            <p>of</p>
            <p>{total}</p>
          </div>

          <div className="pagination-controls">
            <img
              onClick={() => setPage(1)}
              src={backwardIcon}
              alt="First page"
            />
            <img
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              src={backIcon}
              alt="Previous page"
            />
            <img
              onClick={() =>
                setPage((prev) =>
                  Math.min(prev + 1, Math.ceil(total / pageSize))
                )
              }
              src={frontIcon}
              alt="Next page"
            />
            <img
              onClick={() => setPage(Math.ceil(total / pageSize))}
              src={forwardIcon}
              alt="Last page"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
